import { Cartographic, Ellipsoid } from '@skand/three-js-renderer/bin/private/math';
import { Vector3 } from 'three';
import { toCartesian } from '../../../Utils';
/**
 * Imagery globe layer.
 */
export class Imagery {
    /**
     * Create a new Imagery layer model.
     *
     * @param descriptor
     * @param globeService
     */
    constructor(descriptor, globeService) {
        Object.defineProperty(this, "descriptor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "position", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "visible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "globeService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.descriptor = descriptor;
        this.position = new Vector3();
        this.size = Ellipsoid.WGS_84.maximumRadius * 2;
        this.visible = false; // Hidden by default, show model explicitly
        this.globeService = globeService;
    }
    async show() {
        if (!this.visible) {
            this.visible = true;
            const layers = this.globeService.getImageryLayers();
            layers.push(this.descriptor);
            if (this.globeService.getGlobeMode() === 'default') {
                await this.globeService.setGlobeMode('imagery');
            }
            await this.globeService._setImageryLayers(layers);
            this.computeBounds();
        }
        return this;
    }
    async hide() {
        if (this.visible) {
            this.visible = false;
            const layers = this.globeService.getImageryLayers();
            const index = layers.findIndex(descriptor => descriptor === this.descriptor);
            if (index > -1) {
                layers.splice(index, 1);
                await this.globeService._setImageryLayers(layers);
            }
        }
        return this;
    }
    async destroy() {
        await this.hide();
    }
    isVisible() {
        return this.visible;
    }
    isPicked(pick) {
        // TODO?
        return false;
    }
    getBoundingRadius() {
        return this.size;
    }
    getPosition(position) {
        if (!position)
            position = new Vector3();
        return position.copy(this.position);
    }
    /**
     * Compute the position and size of the imagery on the globe.
     */
    computeBounds() {
        const layers = this.globeService.getImageryLayers();
        const bounds = this.globeService.getImageryBounds();
        const index = 1 + layers.findIndex(descriptor => descriptor === this.descriptor);
        if (index) {
            const min = toCartesian(new Cartographic(bounds[index].min.longitude, bounds[index].min.latitude, 0));
            const max = toCartesian(new Cartographic(bounds[index].max.longitude, bounds[index].max.latitude, 0));
            this.position = min.add(max).multiplyScalar(0.5);
            this.size = max.distanceTo(min);
        }
    }
}
